import { Button, Icon } from 'antd';
export const endorseeColumnConfig = [
    {
        title: 'Endorsement ID',
        dataIndex: 'endorsementId',
        key: '0',
        width: 75,
        column: 'id',
        sorter: true
    }, {
        title: 'Endorsee Name',
        dataIndex: 'trainee',
        key: '1',
        width: 75,
        column: 'i.indFname',
        sorter: true
    }, {
        title: 'Flight Training Provider',
        dataIndex: 'provider',
        key: '2',
        width: 100,
        column: 'school.name',
        sorter: true
    }, {
        title: 'Estimated Training Start Date',
        dataIndex: 'startDate',
        key: '3',
        width: 100,
        column: 'estimatedStartDate',
        sorter: true
    }, {
        title: 'Estimated Training End Date',
        dataIndex: 'endDate',
        key: '4',
        width: 100,
        column: 'estimatedEndDate',
        sorter: true
    }, {
        title: 'Date Created',
        dataIndex: 'created',
        key: '5',
        width: 60,
        column: 'createdDate',
        sorter: true
    }, {
        title: 'Training Event Status',
        dataIndex: 'status',
        key: '6',
        width: 70,
        column: 'isEndorsed',
        sorter: true
    }, {
        title: 'Endorsement Email',
        dataIndex: 'viewEmail',
        key: '8',
        width: 80
    }
];


export const endorseeViewColumnConfig = [
    {
        title: 'Endorsement ID',
        dataIndex: 'endorsementId',
        key: '0',
        width: 75,
        column: 'id',
        sorter: true
    }, {
        title: 'Endorsee Name',
        dataIndex: 'trainee',
        key: '1',
        width: 75,
        column: 'i.indFname',
        sorter: true
    }, {
        title: 'Flight Training Provider',
        dataIndex: 'provider',
        key: '2',
        width: 100,
        column: 'school.name',
        sorter: true
    }, {
        title: 'Estimated Training Start Date',
        dataIndex: 'startDate',
        key: '3',
        width: 100,
        column: 'estimatedStartDate',
        sorter: true
    }, {
        title: 'Estimated Training End Date',
        dataIndex: 'endDate',
        key: '4',
        width: 100,
        column: 'estimatedEndDate',
        sorter: true
    }, {
        title: 'Date Created',
        dataIndex: 'created',
        key: '5',
        width: 60,
        column: 'createdDate',
        sorter: true
    }, {
        title: 'Training Event Status',
        dataIndex: 'status',
        key: '6',
        width: 70,
        column: 'isEndorsed',
        sorter: true
    }, {
        title: 'Action',
        dataIndex: 'dodAction',
        key: '7',
        width: 80
    }, {
        title: 'Endorsement Email',
        dataIndex: 'viewEmail',
        key: '8',
        width: 80
    }
];